
import { CommonModule } from "@angular/common";
import { Component, Inject, PLATFORM_ID } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "@services/auth/auth-service";
import { ErrorTexts, JapaneseLabels } from "@utils/japaneseLabels";

/**
 * ResetPassword component.
 * Handles the display and logic for the password reset page,
 * including form state, error handling, and password reset submission.
 */
@Component({
  selector: "app-reset-password",
  standalone: true,

  imports: [CommonModule, FormsModule],
  templateUrl: "./reset-password.html",
  styleUrl: "./reset-password.scss",
})
export class ResetPassword {
  rememberMe: boolean = false;
  // @ViewChild("myModal") myModal!: ElementRef;

  title = "Reset Password";
  password !: string;
  confirmPassword!: string;
  passwordError!: string;
  submitError!: string;
  reset_token!: string;
  isModalOpen = false;
  loading: boolean = false;
  success: boolean = false;
  id!: string;
  japaneseLabels = JapaneseLabels;
  errorTexts = ErrorTexts;

  constructor(
    // private titleService: Title, //Service for setting the title of the page.
    private route: ActivatedRoute,
    private router: Router,
    private authenticateService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  // ngOnInit(): void {
  //   this.reset_token = history.state.resetToken;
  // }
  /**
   * Handles the login form submission event.
   * Prevents the default form submission and processes login logic.
   */
  validation() {

  }
  /**
   * Handles the login form submission event.
   * Prevents the default form submission and processes login logic.
   * 
   * @param event The form submission event
   */
  onSubmit(event: Event) {
    event.preventDefault();
  }

  // validation() {
  //   this.validatePassword();
  // }
  // onSubmit(event: Event) {
  //   event.preventDefault();

  //   this.password = this.password.trim();
  //   this.confirmPassword = this.confirmPassword.trim();
  //   this.validatePassword();
  //   if (this.password !== this.confirmPassword) {
  //     this.submitError = "password not matched";
  //     return;
  //   } else {
  //     const confirmData = {
  //       new_password: this.password,
  //       confirm_password: this.confirmPassword,
  //       reset_token: this.reset_token,
  //     };
  //     this.loading = true;
  //     this.authenticateService.confirmPassword(confirmData).subscribe({
  //       next: () => {
  //         this.loading = false;
  //         this.router.navigate([AppRoutes.SUCCESS]);
  //       },
  //       error: (error) => {
  //         console.error("Login failed:", error);
  //         this.loading = false;
  //         this.submitError = "※認証に失敗しました"; // if fails Set the error message
  //         const message = error?.error?.message || "※認証に失敗しました";
  //         this.submitError = message;
  //       },
  //     });
  //   }
  // }

  // validatePassword() {
  //   const hasLetter = /[a-zA-Z]/.test(this.password);
  //   const hasNumber = /[0-9]/.test(this.password);

  //   if (this.password.length < 6 || !hasLetter || !hasNumber) {
  //     this.passwordError =
  //       "パスワードは6文字以上で、英字と数字の両方を含めてください";
  //     return;
  //   } else {
  //     // eslint-disable-next-line no-restricted-syntax
  //     this.passwordError = ""; // Valid input
  //   }
  // }


}
